import { render, staticRenderFns } from "./choiceChannel.vue?vue&type=template&id=25a88068&scoped=true&"
import script from "./choiceChannel.vue?vue&type=script&lang=js&"
export * from "./choiceChannel.vue?vue&type=script&lang=js&"
import style0 from "./choiceChannel.vue?vue&type=style&index=0&id=25a88068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a88068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a88068')) {
      api.createRecord('25a88068', component.options)
    } else {
      api.reload('25a88068', component.options)
    }
    module.hot.accept("./choiceChannel.vue?vue&type=template&id=25a88068&scoped=true&", function () {
      api.rerender('25a88068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settlement/choiceChannel.vue"
export default component.exports